import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import FuzzyText from './FuzzyText';

const NotFound: React.FC = () => {
  return (
    <div className="min-h-screen pt-16 bg-gradient-to-br from-cosmic-violet/60 via-purple-900/55 to-black/70 flex items-center justify-center relative overflow-hidden">
      {/* Background */}
      <div 
        className="absolute inset-0 bg-cover bg-center bg-no-repeat opacity-10"
        style={{
          backgroundImage: `url('https://images.unsplash.com/photo-1518709268805-4e9042af2ac1?w=1920&h=1080&fit=crop')`
        }}
      />
      
      <motion.div 
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
        className="text-center relative z-10 px-4"
      >
        {/* 404 con efecto FuzzyText */}
        <div className="mb-8 flex justify-center">
          <FuzzyText
            fontSize="clamp(4rem, 15vw, 12rem)"
            fontWeight={900}
            fontFamily="Orbitron, monospace"
            color="#00d4ff"
            baseIntensity={0.15}
            hoverIntensity={0.4}
            enableHover={true}
          >
            404
          </FuzzyText>
        </div>
        
        {/* "Page Not Found" con efecto FuzzyText */}
        <div className="mb-4 flex justify-center">
          <FuzzyText
            fontSize="clamp(1.5rem, 4vw, 3rem)"
            fontWeight={700}
            fontFamily="Orbitron, monospace"
            color="#ffffff"
            baseIntensity={0.12}
            hoverIntensity={0.3}
            enableHover={true}
          >
            Page Not Found
          </FuzzyText>
        </div>
        
        <p className="text-gray-300 font-space-grotesk mb-8 text-base sm:text-lg max-w-md mx-auto">
          The page you're looking for doesn't exist in our digital realm.
        </p>
        <Link to="/">
          <motion.button
            whileHover={{ scale: 1.05, boxShadow: "0 0 25px #00d4ff" }}
            whileTap={{ scale: 0.95 }}
            className="px-8 py-3 bg-gradient-to-r from-cyber-blue to-neon-purple text-white font-space-grotesk font-medium rounded-full glow-border transition-all duration-300"
          >
            Return Home
          </motion.button>
        </Link>
      </motion.div>
    </div>
  );
};

export default NotFound;
